import React from 'react';
import { connect } from 'react-redux';
import { Link, NavLink, Redirect } from 'react-router-dom';
import { clearAuthStateAction, redirectToHomeAction } from '../../redux/actions/auth/AuthActions';
 
const Header = ({ auths, clearAuthStateAction, redirectToHomeAction, ...props}) => {
    const activeStyle = {
        fontWeight: 'bold',
        color: '#0b0040'
    };
    
    let isLoggedIn = JSON.parse(localStorage.getItem('isLoggedIn')) || auths === 'authenticated';

    const handleLogout = () => {
        localStorage.setItem('isLoggedIn', 'false');
        console.log('props', props);
        // window.location.href = '/';
        // history && history.push({
        //     pathname: '/'
        // });
        clearAuthStateAction();
        redirectToHomeAction();
    };
    
    return (
        <nav className="navbar navbar-expand-lg navbar-light bg-light">
            <div className='container'>
                <NavLink className="navbar-brand" to="/">SM</NavLink>
                <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
                    <span className="navbar-toggler-icon"></span>
                </button>
                <div className="collapse navbar-collapse justify-content-between" id="navbarNav">
                    <ul className="navbar-nav">
                        <li className="nav-item active">
                            <NavLink className="nav-link" to="/">Home</NavLink>
                        </li>
                        <li className="nav-item">
                            <NavLink className="nav-link" activeStyle={activeStyle} to="/admin">Admin</NavLink>
                        </li>
                        <li className="nav-item">
                            <NavLink className="nav-link" activeStyle={activeStyle} to="/supplier/login">Supplier</NavLink>
                        </li>
                        <li className="nav-item">
                            <NavLink className="nav-link" activeStyle={activeStyle} to="/customer/login">Customer</NavLink>
                        </li>
                        <li className="nav-item">
                            <NavLink className="nav-link" activeStyle={activeStyle} to="/tracking">Tracking</NavLink>
                        </li>
                        <li className="nav-item">
                            <NavLink className="nav-link" activeStyle={activeStyle} to="/product">Products</NavLink>
                        </li>
                    </ul>
                    <ul className='navbar-nav'>
                        <li className="nav-item">
                            {!isLoggedIn ? (
                                <Link className="nav-link" to="/auth/login">Login</Link>
                            ) : (
                                <button onClick={handleLogout} className="btn nav-link">Logout</button>
                            )}
                        </li>
                    </ul>
                    {auths === true ? <Redirect to='/' /> : null}
                </div>
            </div>
        </nav>
    );
};

const mapStateToProps = (state) => {
    console.log('state', state);
    return {
        auths: state.auths,
    };
};

const mapDispatchToProps = {
    clearAuthStateAction,
    redirectToHomeAction
};

export default connect(mapStateToProps, mapDispatchToProps)(Header);
